// context/CountsContext.js
import { createContext, useContext, useCallback, useReducer } from 'react';
import api from '../utils/axios';
import { useAuth } from './AuthContext';

const CountsContext = createContext();

function reducer(state, action) {
  switch (action.type) {
    case 'SET_COUNTS':
      return action.payload;
    default:
      return state;
  }
}

export function CountsProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, { passengerCount: 0, approverCount: 0, adminCount: 0 });
  const { user, token } = useAuth();

  const refreshCounts = useCallback(async () => {
    if (!token || !user) return;

    const { data } = await api.get('/api/car-bookings/pending-count', {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch({ type: 'SET_COUNTS', payload: data });
  }, [token, user]);

  return (
    <CountsContext.Provider value={{ counts: state, refreshCounts }}>
      {children}
    </CountsContext.Provider>
  );
}

export const useCounts = () => useContext(CountsContext);
